<template functional>
  <span
    :aria-hidden="decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    class="material-design-icon plus-circle-outline-icon"
    role="img"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <svg
      :fill="fillColor"
      class="material-design-icon__svg"
      :width="props.size"
      :height="props.size"
      viewBox="0 0 24 24"
    >
      <path
        d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
      >
        <title>{{ props.title }}</title>
      </path>
    </svg>
  </span>
</template>

<script>
// Componente completamente fusilado de la librería vue-material-design-icons
// ... no ibamos a incluir la librería esa sólo para este icono...
export default {
  name: "VPlusCircleIcon",
  props: {
    title: {
      type: String,
      default: "Plus Circle Outline icon",
    },
    decorative: {
      type: Boolean,
      default: false,
    },
    fillColor: {
      type: String,
      default: "currentColor",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
